module.exports = __webpack_public_path__ + "img/muamalat.ab289736.svg";